"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentHandlerFlags = void 0;
var PaymentHandlerFlags;
(function (PaymentHandlerFlags) {
    PaymentHandlerFlags[PaymentHandlerFlags["None"] = 0] = "None";
    PaymentHandlerFlags[PaymentHandlerFlags["AskPw"] = 1] = "AskPw";
    PaymentHandlerFlags[PaymentHandlerFlags["EnabledBetWeb"] = 2] = "EnabledBetWeb";
    PaymentHandlerFlags[PaymentHandlerFlags["BKPayoutReport"] = 4] = "BKPayoutReport";
    PaymentHandlerFlags[PaymentHandlerFlags["NotificationEMailToCustomer"] = 8] = "NotificationEMailToCustomer";
    PaymentHandlerFlags[PaymentHandlerFlags["NotificationEMailToAccountancy"] = 16] = "NotificationEMailToAccountancy";
    PaymentHandlerFlags[PaymentHandlerFlags["ManualPayout"] = 32] = "ManualPayout";
    PaymentHandlerFlags[PaymentHandlerFlags["PayoutAuthorizationNotRequired"] = 64] = "PayoutAuthorizationNotRequired";
    PaymentHandlerFlags[PaymentHandlerFlags["SubtractiveAmountCalculation"] = 128] = "SubtractiveAmountCalculation";
    PaymentHandlerFlags[PaymentHandlerFlags["PlatformInternal"] = 256] = "PlatformInternal";
    PaymentHandlerFlags[PaymentHandlerFlags["EnabledWebShop"] = 512] = "EnabledWebShop";
    PaymentHandlerFlags[PaymentHandlerFlags["EnabledSmartWeb"] = 1024] = "EnabledSmartWeb";
    PaymentHandlerFlags[PaymentHandlerFlags["SupportsUserDefinedAmount"] = 2048] = "SupportsUserDefinedAmount";
})(PaymentHandlerFlags = exports.PaymentHandlerFlags || (exports.PaymentHandlerFlags = {}));
